<template>
  <div class="facility" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
    <p class="facility__address">
      {{ formattedAddress }}
    </p>
    <template v-if="storeCode">
      <div>|</div>
      <p class="facility__store-code">
        {{ `${$t("message.common.storeCode")}: ${storeCode}` }}
      </p>
    </template>
    <v-tooltip v-if="showCopyButton" bottom>
      <template #activator="{ on, attrs }">
        <button
          class="facility__copy-button"
          :class="{ 'facility__copy-button--ellipsed': isTextEllipsed }"
          v-bind="attrs"
          v-on="on"
          @click.stop="copyAddress"
        >
          <v-icon size="15">mdi-content-copy</v-icon>
        </button>
      </template>
      <span>{{ $t("message.common.copyAddress") }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "FacilityAddress",
  props: {
    formattedAddress: {
      type: String,
      required: true
    },
    storeCode: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      showCopyButton: false,
      isAddressEllipsed: false,
      isStoreCodeEllipsed: false
    };
  },
  computed: {
    isTextEllipsed() {
      return this.isAddressEllipsed || this.isStoreCodeEllipsed;
    }
  },
  mounted() {},

  methods: {
    async onMouseEnter() {
      this.checkEllipsis();
      await this.$nextTick();
      this.showCopyButton = true;
    },
    onMouseLeave() {
      this.showCopyButton = false;
    },
    checkEllipsis() {
      const addressElement = this.$el.querySelector(".facility__address");
      const storeCodeElement = this.$el.querySelector(".facility__store-code");

      if (addressElement) {
        this.isAddressEllipsed =
          addressElement.scrollWidth > addressElement.clientWidth;
      }

      if (storeCodeElement) {
        this.isStoreCodeEllipsed =
          storeCodeElement.scrollWidth > storeCodeElement.clientWidth;
      }
    },
    async copyAddress() {
      await navigator.clipboard.writeText(
        `${this.formattedAddress} ${
          this.storeCode
            ? `| ${this.$t("message.common.storeCode")}: ${this.storeCode}`
            : ""
        }`
      );
      this.$notify({
        group: "default",
        type: "success",
        text: this.$t("message.common.copiedToClipboard")
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.facility {
  position: relative;
  display: flex;
  @include font-size(12px);
  font-weight: 400;
  margin-bottom: 0;
  width: 100%;
  white-space: nowrap;
  color: $text;
  justify-self: flex-start;
  align-items: center;
  gap: $spacing * 0.75;
  height: 17px;

  & > p {
    margin-bottom: 0;
  }

  &__address {
    position: relative;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  &__store-code {
    text-overflow: ellipsis;
    overflow: hidden;
  }

  &__copy-button {
    position: relative;
    right: 1px;
    bottom: 2px;
    background: white;
    border-radius: 4px;
    padding: 2px;
    cursor: pointer;
    box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1);

    &--ellipsed {
      position: absolute;
      right: 1px;
    }

    .v-icon {
      color: $grey-darker;
      pointer-events: none;
    }

    &:hover {
      background: $gray-200;
      box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.2);

      .v-icon {
        color: $primary;
      }
    }
  }
}
</style>
